import React from 'react'
import { pdf } from '@react-pdf/renderer'
import { getData } from '../../../api/indexedDBHandler'
import PairComandTournamentProtocolPDF from './PairComandTournamentProtocolPDF'
import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'

const getname = (teamData, competition_type = 'Рейтинговое соревнование') => {
  console.log('teamData', teamData)
  if (competition_type == 'Рейтинговое соревнование') {
    return teamData?.team_name_ru
  }
  return teamData?.preferred_name == 'en'
    ? teamData?.team_name_en
      ? teamData?.team_name_en
      : teamData?.team_name_ru
    : teamData?.team_name_ru
}
// Выносим логику генерации протокола в отдельную функцию
const generateProtocolData = async (id) => {
  console.log('generateProtocolData', id)
  const resultsU = await getData('teams', 'id', id)
  if (resultsU.length === 0) throw new Error('No team data found')

  const { value: teamValue } = resultsU[0]
  const teamsInfo = Object.values(teamValue).filter(
    (teamEntry) =>
      teamEntry !== null &&
      typeof teamEntry === 'object' &&
      teamEntry.team?.status === 'Заявка одобрена' &&
      teamEntry.team?.status_location === 1
  )
  const resultsT = await getData('tournaments', 'id', id)
  if (resultsT.length === 0) throw new Error('No tournament data found')

  const { value: tournamentValue } = resultsT[0]
  const isFinish = tournamentValue.status_cup === 'Турнир завершен'
  const allLogos = Object.values(tournamentValue.sponsor || {})
  const administrator = Object.values(tournamentValue.administrator || [])

  const resultsS = await getData('stage', 'id', id)
  if (resultsS.length === 0) throw new Error('No stage data found')

  const { value: stageValue } = resultsS[0]
  const data = Object.values(stageValue).filter(
    (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
  )

  const teams = {}
  teamsInfo.forEach((team) => {
    const sp1sports_category = team.athlete[0]?.sports_category
      ? ' (' + team.athlete[0]?.sports_category + ')'
      : ''
    const sp1 = team.athlete[0]?.fio ? team.athlete[0]?.fio : ''

    const sp2sports_category = team.athlete[1]?.sports_category
      ? ' (' + team.athlete[1]?.sports_category + ')'
      : ''
    const sp2 = team.athlete[1]?.fio ? ', ' + team.athlete[1]?.fio : ''

    const sp3sports_category = team.athlete[2]?.sports_category
      ? ' (' + team.athlete[2]?.sports_category + ')'
      : ''
    const sp3 = team.athlete[2]?.fio ? ', ' + team.athlete[2]?.fio : ''

    const name = getname(team.team, tournamentValue?.competition_type)
      ? getname(team.team, tournamentValue?.competition_type)
      : ''
    //   console.log('name', name)
    teams[team.team.id] = {
      id: team.team.id,
      team: name,
      zone: team.team.zona,
      sp:
        sp1 +
        sp1sports_category +
        sp2 +
        sp2sports_category +
        sp3 +
        sp3sports_category,
      sector: team.team.sector,
      totalWeight: 0,
      fishCount: 0,
      biggestFish: 0,
      averageWeight: 0,
      weightDifference: 0,
    }
  })

  // Подсчитываем уловы
  data[0]?.forEach((entry) => {
    // console.log('entry', entry)
    if (entry.fishList && entry.fishList[0].weight === 0) return
    if (teams[entry.teamId] && entry.fishList && entry.fishList.length > 0) {
      const weight = entry.fishList.reduce((sum, fish) => sum + fish.weight, 0)
      const biggestFish = Math.max(...entry.fishList.map((fish) => fish.weight))
      // teams[entry.teamId].sp = sp1
      if (entry.teamName && entry.teamName != '')
        teams[entry.teamId].team = entry.teamName
      teams[entry.teamId].totalWeight += weight
      teams[entry.teamId].fishCount += entry.fishList.length
      teams[entry.teamId].biggestFish = Math.max(
        teams[entry.teamId].biggestFish,
        biggestFish
      )
    } else {
      if (entry.teamName && entry.teamName != '')
        teams[entry.teamId].team = entry.teamName ?? entry.teamName
      //  teams[entry.teamId].sp = sp1
    }
  })

  // Вычисляем средний вес рыбы у каждой команды
  Object.values(teams).forEach((team) => {
    if (team.fishCount > 0) {
      team.averageWeight = Math.round(team.totalWeight / team.fishCount)
    }
  })
  //        console.log('data.forEach:', data)
  //        console.log('teams.forEach:', teams)
  // Группировка команд по зонам
  const zones = {}
  Object.values(teams).forEach((team) => {
    if (!zones[team.zone]) zones[team.zone] = []
    zones[team.zone].push(team)
  })
  // // Определение мест в зонах
  // Object.keys(zones).forEach((zone) => {
  //   zones[zone].sort(
  //     (a, b) =>
  //       b.totalWeight - a.totalWeight ||
  //       b.fishCount - a.fishCount  ||
  //       b.biggestFish - a.biggestFish
  //   )
  //   zones[zone].forEach((team, index) => (team.zoneRank = index + 1))
  // })

  // // Определение общего рейтинга
  // const allTeamsSorted = Object.values(teams).sort(
  //   (a, b) =>
  //     a.zoneRank - b.zoneRank ||
  //     b.totalWeight - a.totalWeight ||
  //     b.fishCount - a.fishCount ||
  //     b.biggestFish - a.biggestFish
  // )
  // allTeamsSorted.forEach(
  //   (team, index) => (team.overallRank = index + 1)
  // )
  // Определение мест в зонах
  // Object.keys(zones).forEach((zone) => {
  //   const teamsInZone = zones[zone]
  //   const totalTeamsInZone = teamsInZone.length // Общее количество команд в зоне

  //   // Разделяем команды на с рыбой и без
  //   const withFish = teamsInZone.filter((team) => team.totalWeight > 0)
  //   const withoutFish = teamsInZone.filter(
  //     (team) => team.totalWeight === 0
  //   )

  //   // Сортируем команды с рыбой по приоритетам:
  //   // 1. Вес (убывание)
  //   // 2. Количество рыбы (убывание)
  //   // 3. Крупная рыба (убывание)
  //   withFish.sort((a, b) => {
  //     if (b.totalWeight !== a.totalWeight)
  //       return b.totalWeight - a.totalWeight
  //     if (b.fishCount !== a.fishCount) return b.fishCount - a.fishCount
  //     return b.biggestFish - a.biggestFish
  //   })

  //   // Назначаем места командам с рыбой с учетом возможных ничьих
  //   let currentZoneRank = 1
  //   for (let i = 0; i < withFish.length; i++) {
  //     if (
  //       i > 0 &&
  //       (withFish[i].totalWeight !== withFish[i - 1].totalWeight ||
  //         withFish[i].fishCount !== withFish[i - 1].fishCount ||
  //         withFish[i].biggestFish !== withFish[i - 1].biggestFish)
  //     ) {
  //       currentZoneRank = i + 1
  //     }
  //     withFish[i].zoneRank = currentZoneRank
  //   }

  //   // ВСЕ команды без рыбы получают последнее место в зоне (равное общему числу команд)
  //   const lastZoneRank = totalTeamsInZone // Например, 8 для зоны из 8 команд

  //   withoutFish.forEach((team) => {
  //     team.zoneRank = lastZoneRank // Все получают zoneRank = 8
  //   })

  //   // Объединяем и обновляем зону
  //   zones[zone] = [...withFish, ...withoutFish]
  // })

  // Добавляем функцию для проверки ничьи между командами
  const isTie = (a, b) => {
    if (a.totalWeight !== b.totalWeight) return false

    const avgWeightA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
    const avgWeightB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
    if (avgWeightA !== avgWeightB) return false

    return a.biggestFish === b.biggestFish
  }

  Object.keys(zones).forEach((zone) => {
    const teamsInZone = zones[zone]
    const totalTeamsInZone = teamsInZone.length

    // Разделяем команды: с рыбой, без рыбы, снятые
    const withFish = teamsInZone.filter(
      (team) => team.totalWeight > 0 && !team.disqualified
    )
    const withoutFish = teamsInZone.filter(
      (team) => team.totalWeight === 0 && !team.disqualified
    )
    const disqualified = teamsInZone.filter((team) => team.disqualified)

    // Сортировка команд с рыбой по правилам:
    // 1. Вес (убывание), 2. Средний вес (возрастание), 3. Крупная рыба (убывание)
    withFish.sort((a, b) => {
      if (b.totalWeight !== a.totalWeight) return b.totalWeight - a.totalWeight

      const avgWeightA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
      const avgWeightB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
      if (avgWeightA !== avgWeightB) return avgWeightA - avgWeightB // Меньший средний вес выше

      return b.biggestFish - a.biggestFish
    })

    // Назначение мест с учетом ничьих
    let currentRank = 1
    for (let i = 0; i < withFish.length; i++) {
      if (i > 0) {
        const prev = withFish[i - 1]
        const curr = withFish[i]
        const isTie =
          prev.totalWeight === curr.totalWeight &&
          prev.totalWeight / prev.fishCount ===
            curr.totalWeight / curr.fishCount &&
          prev.biggestFish === curr.biggestFish
        if (!isTie) currentRank = i + 1
      }
      withFish[i].zoneRank = currentRank
    }

    // Команды без рыбы получают последнее место в зоне
    withoutFish.forEach((team) => {
      team.zoneRank = totalTeamsInZone
    })

    // Снятые команды получают место = totalTeamsInZone + 3
    disqualified.forEach((team) => {
      team.zoneRank = totalTeamsInZone + 3
    })

    zones[zone] = [...withFish, ...withoutFish, ...disqualified]
  })
  const allTeams = Object.values(teams)
  const teamsWithFish = allTeams.filter(
    (team) => team.totalWeight > 0 && !team.disqualified
  )
  const teamsWithoutFish = allTeams.filter(
    (team) => team.totalWeight === 0 && !team.disqualified
  )
  const disqualifiedTeams = allTeams.filter((team) => team.disqualified)
  // Сортируем команды с рыбой
  // Сортировка по зональному месту → весу → среднему весу → крупной рыбе
  teamsWithFish.sort((a, b) => {
    if (a.zoneRank !== b.zoneRank) return a.zoneRank - b.zoneRank
    if (b.totalWeight !== a.totalWeight) return b.totalWeight - a.totalWeight

    const avgWeightA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
    const avgWeightB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
    if (avgWeightA !== avgWeightB) return avgWeightA - avgWeightB

    return b.biggestFish - a.biggestFish
  })

  // Назначение общих мест
  let currentOverallRank = 1
  for (let i = 0; i < teamsWithFish.length; i++) {
    if (i > 0 && !isTie(teamsWithFish[i], teamsWithFish[i - 1])) {
      currentOverallRank = i + 1
    }
    teamsWithFish[i].overallRank = currentOverallRank
  }
  // Команды без рыбы и снятые
  const lastRank = allTeams.length
  teamsWithoutFish.forEach((team) => (team.overallRank = lastRank))
  disqualifiedTeams.forEach((team) => (team.overallRank = lastRank + 3))
  // Объединяем все команды
  const allTeamsSorted = [...teamsWithFish, ...teamsWithoutFish]

  // // Назначаем общие места
  // allTeamsSorted.forEach((team, index) => {
  //   // Все команды без рыбы получают максимальный (последний) номер места
  //   team.overallRank =
  //     team.totalWeight === 0 ? allTeamsSorted.length : index + 1
  // })

  // Определяем команду-лидера
  const leaderWeight =
    allTeamsSorted.length > 0 ? allTeamsSorted[0].totalWeight : 0

  // Вычисляем отставание от лидера
  Object.values(teams).forEach((team) => {
    team.weightDifference = leaderWeight - team.totalWeight
  })
  //       console.log('teams teams teams teams teams:', teams)
  // Поиск самой крупной рыбы
  const biggestFish = Object.values(teams).reduce(
    (max, team) =>
      team.biggestFish > max.weight
        ? { weight: team.biggestFish, team: team.name }
        : max,
    { weight: 0, team: '' }
  )

  // Общие данные по соревнованию
  const totalFishCount = Object.values(teams).reduce(
    (sum, team) => sum + team.fishCount,
    0
  )
  const totalWeight = Object.values(teams).reduce(
    (sum, team) => sum + team.totalWeight,
    0
  )
  const averageFishWeight =
    totalFishCount > 0 ? totalWeight / totalFishCount : 0

  // console.log('Результаты по зонам:', zones)
  // console.log('Общий рейтинг:', allTeamsSorted)
  // console.log('Самая крупная рыба:', biggestFish)
  // console.log('Общее количество пойманной рыбы:', totalFishCount)
  // console.log('Общий вес пойманной рыбы:', totalWeight)
  // console.log('Средний вес всех рыб:', Math.round(averageFishWeight))

  return {
    allLogos,
    mainLogo: getLogoUrl(tournamentValue?.logocup),
    data: allTeamsSorted,
    administrator,
    tournament: tournamentValue,
    date: dateNowProtocol(new Date()),
    totalFishCount: totalFishCount,
    totalWeight: totalWeight,
    averageFishWeight: averageFishWeight,

    biggestFish: biggestFish,
    isFinish: isFinish,
    // isFinish,
    // processedData: [], // Замените на ваши обработанные данные
    // totalFishCount: 0, // Замените на реальные значения
    // totalWeight: 0,
    // averageFishWeight: 0,
    // biggestFish: { weight: 0, pair: '' },
  }
}

const DocProtocolPairComand = ({ isProtocolSvodCallback }) => {}
export default {
  generate: async function (id) {
    try {
      const protocolData = await generateProtocolData(id)
      console.log('DocProtocolPairComand', protocolData)
      const pdfDoc = (
        <PairComandTournamentProtocolPDF
          allLogo={protocolData.allLogos}
          mainLogo={getLogoUrl(protocolData.tournament?.logocup)}
          data={protocolData.data}
          administrator={protocolData.administrator}
          tournament={protocolData.tournament}
          date={dateNowProtocol(new Date())}
          totalFishCount={protocolData.totalFishCount}
          totalWeight={protocolData.totalWeight}
          averageFishWeight={protocolData.averageFishWeight}
          biggestFish={protocolData.biggestFish}
          isfinish={protocolData.isFinish}
        />
      )

      const blob = await pdf(pdfDoc).toBlob()
      const url = URL.createObjectURL(blob)

      const servaurl = await uploadPdfToServer(blob, id)
      return {
        blob,
        previewUrl: servaurl,
        data: protocolData,
      }
    } catch (error) {
      console.error('Ошибка при генерации протокола:', error)
      throw error
    }
  },
}
const uploadPdfToServer = async (blob, id) => {
  try {
    const formData = new FormData()
    formData.append(
      'pdf',
      blob,
      `парный_протокол_${dateNowProtocol(new Date())}.pdf`
    )
    formData.append('id', id)
    formData.append('isPost', 3)

    formData.append('type', 'ProtocolPairComand')
    const response = await fetch(
      'https://www.admin-protocarp.ru/php/uploads/upload.php',
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.ok) {
      const result = await response.json()
      // Обновляем URL на серверный, если нужно
      return { fileUrl: result.fileUrl }
    } else {
      console.error('Ошибка загрузки файла на сервер')
      return { fileUrl: null }
    }
  } catch (error) {
    console.error('Ошибка при загрузке на сервер:', error)
    return { fileUrl: null }
  }
}
